import styled from 'styled-components';
import { COLORS } from '../../../constants/style/color';
import { rem } from '../../../utils/style';

export const BrokerSsoConfigContainer = styled.div`
  background: ${COLORS.White};
  padding: ${rem(40)};
  border: ${rem(1)} solid ${COLORS.CulturedWhite};
  border-radius: ${rem(6)};
  margin-bottom: ${rem(16)};
  transition: all 0.2s ease-in-out;
  border: ${rem(1)} solid ${COLORS.OffWhite};
  box-shadow: 0 2px 20px ${COLORS.SoftShadow};

  @media (min-width: 512px) {
    padding: ${rem(30)} ${rem(46)} ${rem(32)} ${rem(50)};
    margin-left: 5%;
    margin-right: 25%;
  }
`;
export const BrokerSsoConfigPageContainer = styled.div`
  background: ${COLORS.White};
  padding: ${rem(40)};
  border: ${rem(1)} solid ${COLORS.CulturedWhite};
  border-radius: ${rem(6)};
  margin-bottom: ${rem(16)};
  transition: all 0.2s ease-in-out;
  border: ${rem(1)} solid ${COLORS.OffWhite};
  box-shadow: 0 2px 20px ${COLORS.SoftShadow};

  @media (min-width: 512px) {
    padding: ${rem(30)} ${rem(46)} ${rem(32)} ${rem(50)};
    margin-left: 20%;
    margin-right: 20%;
  }
`;
